module.exports = __webpack_public_path__ + "img/ManHoleUp.5f7d7d2a.svg";